import React from "react";
import styles from './loadMore.module.scss';
import PropTypes from "prop-types";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

const LoadMore = ({
  isLoading = false,
  onClick
}) => {
  return (
    <div className={styles.loadMore}>
      {isLoading
        ? <LoadingSpinner size={33} />
        : <button 
            onClick={onClick} disabled={isLoading}>
            Load More
          </button>}
    </div>
  );
};

LoadMore.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

export default LoadMore;